import { Col, Container, Quote, Row, Stars, Typography } from 'darrius';
import { DepoimentsData } from '../../../data/home/homeData';
import styles from './Depoiments.module.scss';

export const Depoiments = ({ reviews = DepoimentsData.reviews }) => {
  return (
    <Container className={styles.depoiments}>
      <Row>
        <Col className="col-sm-12">
          <Typography.Title as="h2" size="3xl" className="headline">
            {DepoimentsData.title}
          </Typography.Title>
        </Col>
      </Row>
      <Row className="row space-between row--slider-sm center-sm">
        {reviews.map((review) => (
          <Col key={review.id} className="col-12 col-sm-12 col-md-4 col-lg-4">
            <div className={styles['category-rating__review']}>
              <Quote />

              <Typography.Text
                className={styles['category-rating__review-text']}
              >
                <i>{review.text}</i>
              </Typography.Text>

              <Typography.Text
                className={styles['category-rating__review-pro']}
              >
                <b>{review.name}</b>, {review.profission}
              </Typography.Text>

              <Stars
                quantity={DepoimentsData.maxStarts}
                rating={review.rating}
              />
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
